<template>
  <div class="pal">
    <label>
      <span v-if="locked" class="af-icons af-icons-lock"></span>
      {{ lang.get('fields.form.type.label') }}
    </label>
    <div class="pull-right">
      <a :href="fieldGuideUrl" target="_blank" rel="noopener noreferrer">
        {{ lang.get('fields.form.type.about') }}
      </a>
    </div>
    <template v-if="locked">
      <div class="form-control configuring">
        {{ lang.get('fields.types.' + field.type) }}
      </div>
    </template>
    <template v-else>
      <select
        class="form-control"
        @change="e => handleInput('type', e.target.value)"
      >
        <option></option>
        <option
          v-for="type in types"
          :key="type"
          :value="type"
          :selected="field.type === type"
          :disabled="disabledTypes.includes(type)"
        >
          {{ lang.get('fields.types.' + type) }}
        </option>
      </select>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import handleInputMixin from '../handle-input-mixin.js';

export default {
  inject: ['lang'],
  mixins: [handleInputMixin],
  props: {
    field: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters('entryForm', ['compatibleTypes']),
    ...mapState('entryForm', [
      'fieldGuideUrl',
      'fieldTypes',
      'fieldCompatibility'
    ]),
    locked() {
      return this.types.length === 0;
    },
    types() {
      if (!this.field.createdAt || !this.field.hasValues) {
        return this.fieldTypes;
      }

      return this.compatibleTypes(this.field.type);
    },
    disabledTypes() {
      if (
        this.field.resource === 'Attachments' ||
        this.field.resource === 'Contributors'
      ) {
        return ['table', 'file'];
      }
      return [];
    }
  }
};
</script>
